import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Sidebar } from "../sidebar";
import { HeaderItem } from "./headerItem";
import { useSelector } from "react-redux";
import menuIcon from "../../images/menu.svg";
import refreshIcon from "../../images/refresh.svg";
import leftArrowIcon from "../../images/left-arrow.svg";
import settingsIcon from "../../images/settings.svg";
import "./index.css";

export function Header(props: any) {
  const [showSidebar, setShowSidebar] = useState(false);

  const headers: any = [];

  const shareApp = () => {
    const bridge = (window as any).NativeNewsBridge;
    if (bridge && bridge.ShareNews) {
      bridge.ShareNews(
        "Strategy Builder",
        "App link: https://play.google.com/store/apps/details?id=com.anand.strategybuilder",
        window.location.href
      );
    }
    hideSidebar();
  };
  const title = props.title || "Strategy Builder";
  const history = useHistory();

  function displaySidebar() {
    setShowSidebar(true);
  }

  function hideSidebar() {
    setShowSidebar(false);
  }

  return (
    <>
      <div className="e-news-header">

        {props.onRefresh && (
          <span className="e-news-refresh" onClick={props.onRefresh}>
            <img alt="home" src={refreshIcon} />
          </span>
        )}
        
        <span className="e-news-title">{title}</span>
        {showSidebar && (
          <Sidebar onClose={hideSidebar}>
            <HeaderItem
              key="whystrategies"
              title="Why Option Strategies"
              className="e-news-settings"
              onClick={() => {
                history.push("/strategies");
              }}
            ></HeaderItem>
            <HeaderItem
              key="riskreward"
              title="Risk Reward Ratio"
              className="e-news-settings"
              onClick={() => {
                history.push("/risk-reward-ratio");
              }}
            ></HeaderItem>
            <HeaderItem
              key="breakeven"
              title="Breakeven"
              className="e-news-settings"
              onClick={() => {
                history.push("/break-even");
              }}
            ></HeaderItem>
            <HeaderItem
              key="strategies"
              title="Option Strategies"
              className="e-news-settings"
              onClick={() => {
                history.push("/why-option-strategies");
              }}
            ></HeaderItem>
            <HeaderItem
              key="contact"
              title="Contact Us"
              className="e-news-settings"
              onClick={() => {
                history.push("/contact");
              }}
            ></HeaderItem>
            <HeaderItem
              key="shareApp"
              onClick={shareApp}
              className="e-news-settings"
              title="Share this App"
            ></HeaderItem>
          </Sidebar>
        )}
      </div>
    </>
  );
}
